<template>
  <template v-for="code in errorAlerts" :key="code">
    <UAlert
      :title="t(`error.${code}`)"
      color="error"
      variant="soft"
      icon="i-heroicons-x-circle"
      orientation="horizontal"
      :actions="getActions(code)"
      class="mb-2"
    />
  </template>
</template>

<script setup lang="ts">
import type { ButtonProps } from '@nuxt/ui'
import { API_ERROR_CODES_WITH_MESSAGE } from '../../constants'

interface propsInterface {
  apiResponseError: ApiResponseError | null
}
const props = defineProps<propsInterface>()

type ErrorCode =
  (typeof API_ERROR_CODES_WITH_MESSAGE)[keyof typeof API_ERROR_CODES_WITH_MESSAGE]

const actionsByCode: Partial<Record<ErrorCode, ButtonProps[]>> = {
  0: [
    {
      to: routes().contact(),
      label: t('error.actions.contact'),
      rel: 'nofollow',
      external: true,
      color: 'neutral',
      variant: 'solid',
    },
  ],
  3000: [
    {
      to: routes().rememberPassword(),
      label: t('error.actions.rememberPassword'),
      rel: 'nofollow',
      external: true,
      color: 'neutral',
      variant: 'solid',
    },
  ],
  3002: [
    {
      to: routes().travelerRegistration(),
      label: t('error.actions.travelerRegistration'),
      rel: 'nofollow',
      external: true,
      color: 'neutral',
      variant: 'solid',
    },
  ],
  4005: [
    {
      to: routes().contact(),
      label: t('error.actions.contact'),
      rel: 'nofollow',
      external: true,
      color: 'neutral',
      variant: 'solid',
    },
  ],
  4006: [
    {
      to: routes().contact(),
      label: t('error.actions.contact'),
      rel: 'nofollow',
      external: true,
      color: 'neutral',
      variant: 'solid',
    },
  ],
  10000: [
    {
      to: routes().contact(),
      label: t('error.actions.contact'),
      rel: 'nofollow',
      external: true,
      color: 'neutral',
      variant: 'solid',
    },
  ],
}

const getActions = (code: ErrorCode): ButtonProps[] | undefined =>
  actionsByCode[code]

const genericErrorText: ErrorCode[] = [0]

const errorAlerts = computed<ErrorCode[]>(() => {
  if (!props.apiResponseError) return []
  if (!props.apiResponseError.errors?.length) return genericErrorText

  const filtered = props.apiResponseError.errors
    .map(item => item.code)
    .filter((code): code is ErrorCode => code in API_ERROR_CODES_WITH_MESSAGE)

  return filtered.length ? filtered : genericErrorText
})
</script>
